import { apolloProvider } from '@/plugins/apollo';
import userInfoQuery from '@/api/user/userInfo.gql';

import Vue from 'vue';

async function getUserData() {
  const { data } = await apolloProvider.defaultClient.query({ query: userInfoQuery });
  return ((data || {}).koeeBoxQuery || {}).currentUser || null;
}

export default {
  state: {
    user: {
      data: {},
      previewMode: sessionStorage?.getItem('previewCard') || false,
    },
  },
  mutations: {
    SET_ADDITIONAL_DATA(state, payload) {
      state.user.data = payload;
    },
    SET_PREVIEW_MODE(state, payload) {
      state.user.previewMode = payload;
      sessionStorage.setItem('previewCard', payload);
    },
    REMOVE_PREVIEW_MODE(state) {
      state.user.previewMode = false;
      sessionStorage.removeItem('previewCard');
    },
  },
  actions: {
    async SET_ADDITIONAL_DATA({ commit, getters, dispatch }) {
      commit('SET_ADDITIONAL_DATA', await getUserData());
      if (getters.userId) {
        dispatch('SET_AVAILABLE_FEATURES');
      }
    },
  },
  getters: {
    userName(state) {
      return (state.user.data || {}).fullName;
    },
    userGroup(state) {
      return (state.user.data || {}).group;
    },
    userPhoto(state) {
      return ((state.user.data || {}).attachmentPhoto || {}).url || '';
    },
    userId(state) {
      return (state.user.data || {}).id;
    },
    userObject(state) {
      return ((state.user.data || {}).itObject || {}).name;
    },
    userObjectId(state) {
      return ((state.user.data || {}).itObject || {}).id;
    },
    isDemo(state) {
      return ((state.user.data || {}).itObject || {}).id === 'DEFLT';
    },
    isPreview(state) {
      return state.user.previewMode;
    },
    isAdmin() {
      return Vue.$authCore.userRole == 'Admin';
    },
    isUser() {
      return Vue.$authCore.userRole == 'User';
    },
    isGuest() {
      return Vue.$authCore.userRole == 'Guest';
    },
    groupIdPm() {
      return 'OEE_PM';
    },
    groupIdPUser() {
      return 'OEE_USER';
    },
  },
};
